import Isotope from 'isotope-layout';

var elems = document.querySelectorAll('.js-Masonry');

elems.forEach(element => {
  new Isotope( element, {
    itemSelector: '.masonry__item',
    layoutMode: 'masonry'
  });

});
